import { all, fork } from "redux-saga/effects";
import user from "./user";
import upload from "./upload";

/**
 * rootSaga
 */
export default function* root() {
  yield all([
    fork(upload),
    fork(user),
  ]);
}
